module.exports = __webpack_public_path__ + "img/ring_y_s_0_null@2x.9475e34f.png";